// Path: src\Components\Profile\Profile.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseHome from "../Home/BaseHome";
import Userchar from "../../assets/images/userchar.png";
import LevelIcon from "../../assets/images/levelicon1.png";
import Premiumuser from "../../assets/images/premiumicons.png";
import { getProfile, getStats } from "../../api/profile.api";
import { url } from "../../config/url";
import User from "../../assets/images/user-icon.svg";
import LevelsPopup from "../Popup/LevelsPopup";
import { useNavigate } from "react-router";
import ListLoader from "../Common/ListLoader";
import { t } from "i18next";
import ProfileSubscriptionPopup from './ProfileSubscriptionPopup'

const Profile = (isOpen, onClose) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("stats");
  const [userProfile, setUserProfile] = useState("");
  // const [isLevelsPopup, setIsLevelsPopup] = useState(true)
  const [loading, setLoading] = useState(false);
  const [isLevelsPopup, setIsLevelsPopup] = useState(false);
  const [tournamentData, setTournamentData] = useState([]);
  const [rank, setRank] = useState([]);
  const [totalPlayed, setTotalPlayed] = useState([]);
  const [won, setWon] = useState([]);
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [showSubscriptionPopup, setSubscriptionPopup] = useState(false)

  const clickHandler = (name, id) => {
    // localStorage.setItem("activeGame", name);
    // localStorage.setItem("activeGameId", id);
    navigate("/edit/profile");
  };
  useEffect(() => {
    fetchUserProfile();
    fetchStats();
    var isPremium = localStorage?.getItem('premiumUser') || false
    setIsPremiumUser(isPremium == true || isPremium == "true" ? true : false)
    isPremium = isPremium == true || isPremium == "true" ? true : false
    if(!isPremium) {
      setSubscriptionPopup(true)
    }
  }, []);

  const fetchStats = async () => {
    try {
      const res = await getStats();
      if (res?.success && res?.data) {
        setTournamentData(res.data);
        setRank(res?.totalRank);
        setTotalPlayed(res?.totalPlayed);
        setWon(res?.totalWon);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const res = await getProfile();
      if (res?.success && res?.data) {
        setUserProfile(res?.data);
      } else {
        setUserProfile("");
      }
      setLoading(false);
    } catch (error) {
      setUserProfile("");
      setLoading(false);
    }
  };

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleOpenLevelsPopup = () => {
    setIsLevelsPopup(true);
  };

  let currentLevelPoints =
    (userProfile?.level?.endPoint || 0) -
    ((userProfile?.level?.startPoint || 0) - 1);
  let userPointsAsPerLevel =
    (userProfile?.totalPoint || 0) -
    ((userProfile?.level?.startPoint || 0) - 1);

  let percentage = (userPointsAsPerLevel * 100) / currentLevelPoints;

  return (
    <BaseHome
      title={t("profile.profile")}
      isFooter={true}
      notBack={true}
      MaxFullPageScroll={true}
    >
      <div className="userprofile-esports-container">
        {!loading ? (
          <>
            <div className="userprofile-esports-header">
              <div className="userprofile-esports-userinfo-img-wrap">
                <div className="userprofile-esports-userinfo-wrap">
                  <div className="userprofile-esports-userinfo">
                    <div className="userprofile-name-svg-flex">
                      {isPremiumUser && 
                        <div className="players-table-img d-flex" style={{marginTop: "-3px"}}>
                          <img src={Premiumuser} />
                        </div>
                      }
                      <div className="userprofile-esports-username">
                        {userProfile?.gamerjiName?.length > 20 ? (
                          <marquee> {userProfile?.gamerjiName}</marquee>
                        ) : (
                          userProfile?.gamerjiName
                        )}

                        {/* {userProfile?.gamerjiName} */}
                      </div>
                      <div
                        className="userprofile-svg-editicon"
                        onClick={() => clickHandler()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          className="custom-svg-userprofile" // Add class for styling
                        >
                          <rect
                            width="14"
                            height="14"
                            fill="#EE2737"
                            className="custom-rect-userprofile"
                          />
                          <path
                            d="M11.9463 11.5768V5.75475C11.9412 5.67723 11.9089 5.60463 11.8558 5.55162C11.8028 5.49861 11.7329 5.46913 11.6603 5.46913C11.5877 5.46913 11.5178 5.49861 11.4647 5.55162C11.4117 5.60463 11.3794 5.67723 11.3743 5.75475V11.5768C11.3741 11.6679 11.3572 11.7581 11.3243 11.8422C11.2915 11.9263 11.2435 12.0026 11.1831 12.0667C11.1226 12.1309 11.0509 12.1816 10.9721 12.2161C10.8933 12.2505 10.809 12.2679 10.7238 12.2673H2.70852C2.53757 12.2669 2.37373 12.194 2.25286 12.0646C2.13198 11.9352 2.06391 11.7598 2.06354 11.5768V2.99569C2.06391 2.81268 2.13198 2.63727 2.25286 2.50786C2.37373 2.37845 2.53757 2.30558 2.70852 2.30519H8.1467C8.18434 2.30519 8.22162 2.29725 8.2564 2.28183C8.29118 2.2664 8.32278 2.2438 8.3494 2.2153C8.37602 2.1868 8.39713 2.15297 8.41154 2.11574C8.42594 2.0785 8.43336 2.0386 8.43336 1.9983C8.43336 1.95799 8.42594 1.91809 8.41154 1.88085C8.39713 1.84362 8.37602 1.80979 8.3494 1.78129C8.32278 1.75279 8.29118 1.73019 8.2564 1.71477C8.22162 1.69934 8.18434 1.69141 8.1467 1.69141H2.70852C2.38563 1.69219 2.07618 1.82985 1.84787 2.07428C1.61955 2.31871 1.49096 2.65001 1.49023 2.99569V11.5768C1.49096 11.9225 1.61955 12.2538 1.84787 12.4982C2.07618 12.7426 2.38563 12.8803 2.70852 12.8811H10.7238C10.8841 12.8815 11.0429 12.848 11.1911 12.7827C11.3393 12.7173 11.474 12.6213 11.5876 12.5002C11.7011 12.3791 11.7912 12.2352 11.8528 12.0767C11.9143 11.9183 11.9461 11.7484 11.9463 11.5768Z"
                            fill="white"
                            className="custom-path-userprofile"
                          />
                          <path
                            d="M5.23099 7.32941C5.15805 7.40424 5.104 7.49764 5.07389 7.60089L4.50195 9.65174L6.42309 9.04534C6.51937 9.01478 6.607 8.959 6.67805 8.88304L11.3638 3.87394L9.90982 2.32031L5.23099 7.32941Z"
                            fill="white"
                            className="custom-path-userprofile"
                          />
                          <path
                            d="M12.5166 2.17437C12.517 1.9574 12.4572 1.74518 12.3448 1.56465C12.2324 1.38412 12.0724 1.24342 11.8852 1.16042C11.6979 1.07742 11.4919 1.05586 11.2931 1.09847C11.0944 1.14109 10.912 1.24596 10.7691 1.39977L10.3115 1.88666L11.7627 3.43881L12.2175 2.95192C12.3131 2.85011 12.3888 2.7289 12.4402 2.59539C12.4915 2.46188 12.5175 2.31875 12.5166 2.17437Z"
                            fill="white"
                            className="custom-path-userprofile"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="userprofile-esports-followers">
                      <div className="userprofile-flex">
                        <div className="user-profile-followers-total">
                          {userProfile?.followers || 0} 
                        </div>
                        <div className="user-profile-followers-title">
                        {/* {userProfile?.followers === 1 ? 'follower' : 'followers'} */}
                        {userProfile?.followers <= 1 ? 'follower' : 'followers'}
                        </div>
                      </div>
                      <div className="userprofile-flex profile-child">
                        <div className="user-profile-followers-total">
                          {userProfile?.followings || 0}
                        </div>
                        <div className="user-profile-followers-title">
                          following
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="userprofile-esports-level">
                  <div className="userprofile-esports-level-icon">
                    {userProfile?.level?.featuredImage?.default ? (
                      <img
                        src={
                          url?.IMAGE_URL +
                          userProfile?.level?.featuredImage?.default
                        }
                        alt={userProfile?.level?.name}
                      />
                    ) : (
                      <img src={User} alt={userProfile?.level?.name} />
                    )}
                  </div>
                  <div className="userprofile-esports-level-info">
                    <div className="user-profile-levelname">
                      {userProfile?.level?.name}
                    </div>

                    <div className="user-profile-levels-flex">
                      <div className="user-profile-levels">
                        Level {userProfile?.level?.num || 0}
                      </div>
                      <div className="user-profile-levels">
                        {userProfile?.totalPoint || 0} points
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-1">
                      {/* Progress Bar */}
                      <div
                        className="progress"
                        style={{ height: "6px", width: "100%" }}
                      >
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${percentage}%`, // Dynamically set width
                            backgroundColor: "#9F6693", // Change color if 100%
                          }}
                          aria-valuenow={userProfile?.level?.startPoint || 0}
                          aria-valuemin="0"
                          aria-valuemax={userProfile?.level?.endPoint || 0}
                        ></div>
                      </div>
                    </div>

                    <p className="progressbar-text user-profile-progressbar mt-1">
                      <div>{userProfile?.level?.startPoint || 0} pts</div>
                      <div>{userProfile?.level?.endPoint || 0} pts</div>
                    </p>
                  </div>
                </div>
                <div
                  className="all-levels-user-profile"
                  style={{ cursor: "pointer" }}
                  onClick={handleOpenLevelsPopup}
                >
                  {t("profile.allLevel")}
                </div>
              </div>
              <div className="userprofile-esports-avatar">
                <img
                  src={url?.IMAGE_URL + userProfile?.avatar?.img?.default}
                  alt="Avatar"
                  style={{ objectFit: "contain" }}
                />
              </div>
            </div>

            <div className="userprofile-esports-stats userprofile-esports-stats-1"></div>
            <div className="userprofile-esports-ranking">
              <div className="user-profiles-dflex">
                <div className="userprofile-ranks-details">#{rank}</div>
                <div className="userprofile-ranks-details-ranks">rank</div>
              </div>
              <div className="user-profiles-dflex">
                <div className="userprofile-ranks-details">#{totalPlayed} </div>
                <div className="userprofile-ranks-details-ranks">played</div>
              </div>

              <div className="user-profiles-dflex">
                <div className="userprofile-ranks-details">#{won}</div>
                <div className="userprofile-ranks-details-ranks">won</div>
              </div>
            </div>

            {tournamentData?.length > 0 ? (
              <div className="userprofiles-tab-container mt-4">
                <button className="userprofiles-tab-btn  active">
                  {t("profile.stats")}
                </button>
              </div>
            ) : (
              <></>
            )}

            <div className="userprofiles-tab-content mt-4">
              {activeTab === "stats" && (
                <div className="container tournament-card--wrap user-profile-spacing mt-3">
                  {tournamentData?.length > 0
                    ? tournamentData.map((tournament, index) => (
                        <div className="tournament-card stat-tournament-card" key={index}>
                          <div className="card-body d-flex flex-column justify-content-between">
                            <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex justify-content-between align-items-center">
  <div className="card-title card-title-name-ellipsis card-title-name-ellipsis-1">
    {tournament.gameName?.toLowerCase()} - {tournament.userInGameName?.toLowerCase()}
  </div>
</div>
                            </div>
                            <hr style={{ margin: "8px 0" }} />
                            <div className="row mt-3">
                              <div className="col-12">
                                <div className="tournament-card-detail stat-tournament-card-detail">
                                  {/* Tournament details */}
                                  <div className="row">
                                    <div className="col-12 tournament-card-box--wrap">
                                      <div className="row">
                                        <div className="col-4 tournament-card-box">
                                          <div className="detail-item">
                                            <div className="tournament-detail-label">
                                              #{tournament.rank}
                                            </div>
                                            <div className="tournament-detail-value">
                                              rank
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-4 tournament-card-box">
                                          <div className="detail-item">
                                            <div className="tournament-detail-label">
                                              #{tournament.played}
                                            </div>
                                            <div className="tournament-detail-value">
                                              played
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-4 tournament-card-box">
                                          <div className="detail-item">
                                            <div className="tournament-detail-label">
                                              #{tournament.won}
                                            </div>
                                            <div className="tournament-detail-value">
                                              won
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="col-3 tournament-card-box">
                                          <div className="detail-item">
                                            <div className="tournament-detail-label">
                                              {tournament.top}
                                            </div>
                                            <div className="tournament-detail-value">
                                              top 10
                                            </div>
                                          </div>
                                        </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    : !loading && (
                        <>
                          {" "}
                          <div
                            className="text-center"
                            style={{ width: "100%" }}
                          >
                            <span className="text-center">no data found</span>
                          </div>
                        </>
                      )}
                  {loading && (
                    <div className="w-100 d-flex justify-content-center">
                      {" "}
                      <ListLoader />
                    </div>
                  )}
                </div>
              )}
              {activeTab === "collegiate" && <div>no data found</div>}
            </div>
            {isLevelsPopup && (
              <LevelsPopup
                isOpen={isLevelsPopup}
                title="levels"
                onClose={() => setIsLevelsPopup(false)}
              />
            )}
            {
                showSubscriptionPopup &&
                <ProfileSubscriptionPopup
                    isOpen={showSubscriptionPopup}
                    onClose={() => setSubscriptionPopup(false)} title={"explore vi premium"}
                    onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }} />
            }
          </>
        ) : (
          !loading && (
            <>
              <div
                className="text-center no-record-found-center"
                style={{ width: "100%" }}
              >
                <span className="text-center">no data found</span>
              </div>
            </>
          )
        )}

        {loading && (
          <div className="w-100 d-flex justify-content-center no-record-found-center">
            {" "}
            <ListLoader />
          </div>
        )}
      </div>
    </BaseHome>
  );
};

export default Profile;
